import React, { useState } from 'react';
import { Box, IconButton, Tooltip, Typography, useTheme } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { useCaseStatusLanguage } from '../../../../routes/CaseStatus/CaseStatusLanguageProvider';

type PaymentRowProps = {
  label: string;
  value: string;
  copyValue: string;
  large?: boolean;
};

const PaymentRow = ({ label, value, copyValue, large = false }: PaymentRowProps) => {
  const theme = useTheme();
  const { t } = useCaseStatusLanguage();
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(copyValue).catch(() => {});
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        backgroundColor: theme.palette.grey[100],
        borderRadius: `${theme.shape.borderRadius}px`,
        px: 1.5,
        py: 1,
        mb: 1,
      }}
    >
      <Box>
        <Typography
          variant="caption"
          sx={{
            color: large ? theme.palette.success.main : 'text.secondary',
            fontWeight: large ? 600 : 400,
            display: 'block',
          }}
        >
          {label}
        </Typography>
        <Typography
          variant={large ? 'h5' : 'body1'}
          component="p"
          sx={{ fontWeight: 'bold', fontVariantNumeric: 'tabular-nums', lineHeight: 1.3 }}
        >
          {value}
        </Typography>
      </Box>

      <Tooltip
        open={copied}
        title={t('Copied')}
        placement="bottom"
        arrow
        slotProps={{
          tooltip: {
            sx: {
              bgcolor: 'white',
              color: 'success.main',
              fontSize: '0.75rem',
              boxShadow: 1,
            },
          },
          arrow: { sx: { color: 'white' } },
        }}
      >
        <IconButton size="small" aria-label={`${t('Copy')} ${label}`} onClick={handleCopy}>
          <ContentCopyIcon
            sx={{
              fontSize: 18,
              color: copied ? theme.palette.success.main : theme.palette.grey[400],
            }}
          />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default PaymentRow;
